import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const HeroBanner = () => {
  return (
    <HeroContainer>
      <HeroImage
        src="https://firebasestorage.googleapis.com/v0/b/champion-building.appspot.com/o/construction.jpg?alt=media&token=905db3e5-0964-4c5a-8b59-618ff6676cf2"
        alt="Champion and Champion Construction"
      />
      <HeroOverlay />
      <HeroContent>
        <HeroEyebrow>Contractor &nbsp;·&nbsp; Los Angeles, CA</HeroEyebrow>
        <HeroHeading>
          Build Your Dreams with<br />Champion &amp; Champion
        </HeroHeading>
        <HeroTagline>Transforming Spaces, Creating Legacies</HeroTagline>
        <HeroActions>
          <PrimaryBtn as={Link} to="/contact">Get a Free Quote</PrimaryBtn>
          <SecondaryBtn as={Link} to="/roofing">View Our Work</SecondaryBtn>
        </HeroActions>
      </HeroContent>
    </HeroContainer>
  );
};

const HeroContainer = styled.section`
  position: relative;
  width: 100%;
  height: 100vh;
  min-height: 600px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeroImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
`;

const HeroOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    160deg,
    rgba(0, 0, 0, 0.25) 0%,
    rgba(0, 0, 0, 0.55) 40%,
    rgba(0, 0, 0, 0.78) 100%
  );
  z-index: 1;
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 0 24px;
  max-width: 860px;
`;

const HeroEyebrow = styled.p`
  font-family: "Poppins", sans-serif;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #c89432;
  margin-bottom: 20px;
  @media (max-width: 480px) {
    font-size: 0.7rem;
    letter-spacing: 2px;
  }
`;

const HeroHeading = styled.h1`
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: clamp(2rem, 5vw, 3.75rem);
  line-height: 1.15;
  color: #ffffff;
  margin-bottom: 20px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
`;

const HeroTagline = styled.p`
  font-family: "Poppins", sans-serif;
  font-size: clamp(1rem, 1.8vw, 1.25rem);
  font-weight: 300;
  color: rgba(255, 255, 255, 0.88);
  margin-bottom: 44px;
  letter-spacing: 1px;
`;

const HeroActions = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
`;

const PrimaryBtn = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 15px 38px;
  background: #c89432;
  color: #fff;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  border-radius: 4px;
  border: 2px solid #c89432;
  transition: background 0.25s ease, transform 0.2s ease, box-shadow 0.25s ease;
  cursor: pointer;
  &:hover {
    background: #a97a20;
    border-color: #a97a20;
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(200, 148, 50, 0.4);
  }
`;

const SecondaryBtn = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 15px 38px;
  background: transparent;
  color: #fff;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  border-radius: 4px;
  border: 2px solid rgba(255, 255, 255, 0.7);
  transition: background 0.25s ease, border-color 0.25s ease, transform 0.2s ease;
  cursor: pointer;
  &:hover {
    background: rgba(255, 255, 255, 0.12);
    border-color: #fff;
    transform: translateY(-2px);
  }
`;

export default HeroBanner;
